// エンコード Worker の生成（webpack が Worker を別チャンクにするため new URL(..., import.meta.url) の形で書く）
export const createEncodeWorker = () => new Worker(new URL('./encode.worker.js', import.meta.url));
